<template lang="pug">
  div.header-bubbles-container
    //- 签到弹窗悬浮球
    .sign-in-bubble-area(v-if="signExtInfo.bountyCountToday || signExtInfo.bountyCountTomorrow")
      SignInBubble(
        :extInfo="signExtInfo"
        @bubbleClick="handleSignBubbleClick"
      )
    //- 单单返悬浮球
    .award-levitated-sphere-area(v-if="isShowDDFEntry()")
      AwardLevitatedSphere(
        :rewardCount="rewardCount"
        :isDueSoon="isDueSoon"
        @awardClick="handleAwardClick"
      )

    //- 单单返奖励引导弹窗
    AwardGuidePopup(
      :visible="awardGuidePopupVisible"
      :list="taskAwardList"
      :extInfo="taskAwardExtInfo"
      @close="handleAwardGuidePopupClose"
    )
</template>

<script>
import eventBus from '@/const/eventBus';
import { Storage } from '@/utils/storage';
import Loading from '@/components/loading';
import { getTaskAwardListData } from '../../common/helper';
import AwardLevitatedSphere from './award-levitated-sphere';
import AwardGuidePopup from '../../new-version-cpns/award-guide-popup';
import SignInBubble from './sign-in-bubble';
import {
  AWARD_COIN_STATUS,
  STORAGE_KEY_SHOW_AWARD_GUIDE,
} from '../../consts';

export default {
  name: 'HeaderBubbles',
  components: {
    SignInBubble,
    AwardLevitatedSphere,
    AwardGuidePopup,
  },
  props: {
    // 单单返奖励金数量
    rewardCount: {
      type: Number,
      default: 0,
    },
    // 单单返是否即将过期
    isDueSoon: {
      type: Boolean,
      default: false,
    },
    // 签到扩展信息（由父级 index 传入）
    signExtInfo: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {
      // 单单返奖励引导弹窗是否显示
      awardGuidePopupVisible: false,
      // 单单返任务奖励列表
      taskAwardList: [],
      // 单单返浮层拓展信息
      taskAwardExtInfo: {},
    };
  },
  inject: {
    isShowDDFEntry: {
      from: 'isShowDDFEntry',
      default: () => () => false,
    },
    currentlyIsVip: { from: 'currentlyIsVip', default: () => false },
  },
  created() {
    // 单单返弹层展示监听
    eventBus.$on('showAwardGuidePopup', this.showAwardGuidePopup);
  },
  beforeDestroy() {
    // 移除单单返弹层展示监听
    eventBus.$off('showAwardGuidePopup', this.showAwardGuidePopup);
  },
  methods: {
    // 展示单单返引导弹窗
    showAwardGuidePopup() {
      const awardGuide = Storage.getItem(STORAGE_KEY_SHOW_AWARD_GUIDE);
      if (awardGuide !== 'YES') {
        this.getTaskAwardList();
      }
      // 奖励领取仅展示一次
      Storage.setItem(STORAGE_KEY_SHOW_AWARD_GUIDE, 'YES');
    },
    // 点击奖励
    handleAwardClick(awardStatus) {
      if (awardStatus === AWARD_COIN_STATUS.NORMAL) {
        this.getTaskAwardList();
      } else {
        this.$emit('awardClick');
      }
    },
    // 获取单单返任务奖励列表
    async getTaskAwardList() {
      Loading.show();
      const { taskAwardList, ariesData } = await getTaskAwardListData({
        isVip: this.currentlyIsVip(),
      });

      if (taskAwardList.length !== 0) {
        this.taskAwardList = taskAwardList;
        this.taskAwardExtInfo = ariesData;
        this.awardGuidePopupVisible = true;
      }
      Loading.close();
    },
    // 关闭单单返奖励引导弹窗
    handleAwardGuidePopupClose() {
      this.awardGuidePopupVisible = false;
    },
    // 签到气泡点击
    async handleSignBubbleClick() {
      this.$emit('signBubbleClick');
    },
  },
};
</script>

<style lang="less" scoped>
.header-bubbles-container {
  display: flex;
  height: 100%;

  .sign-in-bubble-area {
    margin-right: 0.04rem;
    // 需要添加z-index，修复单单反手指动画遮盖签到入口
    position: relative;
    z-index: 2;

    &:last-child {
      margin-right: 0;
    }
  }
}
</style>
